import React from 'react';
import CheckboxGroupFilter from 'shared/components/filters/checkbox-group-filter';
import Text from 'shared/components/text';
import ExpandableFilter from 'src/components/CollegeSearch/Filters/expandable-filter';
import useUserType from 'src/hooks/use-user-type/use-user-type';

export const TYPES = {
  'Liberal Arts': 'Liberal Arts Colleges',
  Research: 'Research Universities',
  'Non Research Universities': 'Non Research Universities',
};

interface TypeFiltersProps {
  getColleges: () => void;
}

const TypeFilters = ({getColleges}: TypeFiltersProps) => {
  const {isTransfer} = useUserType();

  return (
    <div className="college-search-filters-section">
      <fieldset role="group" aria-label="Filter by College Type">
        <legend className="college-search-filters-section-legend">
          <Text weight={5} emphasis>
            College Type
          </Text>
        </legend>
        <CheckboxGroupFilter
          name="control"
          options={{Public: 'Public', Private: 'Private'}}
          onChange={getColleges}
        />
        <div className="college-search-subdivider"></div>
        {!isTransfer && (
          <CheckboxGroupFilter
            options={{1: 'Community College'}}
            name="community-college"
            onChange={getColleges}
          />
        )}
        <CheckboxGroupFilter
          options={{1: 'Trade School'}}
          name="trade-school"
          onChange={getColleges}
        />
        <div className="college-search-subdivider"></div>
        <CheckboxGroupFilter name="type" options={TYPES} onChange={getColleges} />
        <ExpandableFilter filterType="College" startClosed>
          <div className="college-search-subdivider"></div>
          <CheckboxGroupFilter
            options={{1: 'Historically Black College'}}
            name="historically-black"
            onChange={getColleges}
          />
          <CheckboxGroupFilter
            options={{1: 'Hispanic-Serving Institution'}}
            name="hispanic-serving"
            onChange={getColleges}
          />
          <CheckboxGroupFilter
            options={{1: 'Tribal College / University'}}
            name="tribal"
            onChange={getColleges}
          />
          <div className="college-search-subdivider"></div>
          <CheckboxGroupFilter
            options={{Womens: "Women's College", Mens: "Men's College"}}
            name="single-sex"
            onChange={getColleges}
          />
        </ExpandableFilter>
      </fieldset>
    </div>
  );
};

export default TypeFilters;
